import React from "react";
import MainPage from "./pages/Main";
import "./scss/styles.scss"

function App() {
  return (
    <div >
      <MainPage />
    </div>
  );
}
export default App;
